export type HomepageDemoStack = {
  id: "data-platform" | "app-services" | "network";
  name: string;
  actions: string;
  changeSummary: string;
  baselineScore: number;
  candidateScore: number;
  rangeLabel: string;
  status: "investigate" | "routine";
  assessment: string;
  headline: string;
  explanation: string;
  baseline: string;
};

/**
 * Small, intentionally illustrative projection of the curated `/demo` story.
 * The live demo resolves its project and comparison from the fixtures backend;
 * this marketing preview stays synchronous, honest, and cheap to render.
 */
export const HOMEPAGE_DEMO_STACKS: readonly HomepageDemoStack[] = [
  {
    id: "data-platform",
    name: "data-platform",
    actions: "+2 ~2 -3 R1",
    changeSummary: "2 add · 2 change · 3 destroy · 1 replace",
    baselineScore: 3.72,
    candidateScore: 14.72,
    rangeLabel: "Far outside its recent range",
    status: "investigate",
    assessment: "Destructive change not seen recently",
    headline: "This stack broke its recent pattern.",
    explanation:
      "Three destroys and one replacement appear where recent successful runs showed no destructive changes.",
    baseline: "Recent successes: adds and updates, no destroys",
  },
  {
    id: "app-services",
    name: "app-services",
    actions: "+3 ~2",
    changeSummary: "3 add · 2 change · 0 destroy",
    baselineScore: 4.1,
    candidateScore: 4.1,
    rangeLabel: "Inside its recent range",
    status: "routine",
    assessment: "Routine",
    headline: "This stack matches its recent pattern.",
    explanation:
      "The candidate contains ordinary additions and updates with no new destructive behavior.",
    baseline: "Recent successes: similar additions and updates",
  },
  {
    id: "network",
    name: "network",
    actions: "~1",
    changeSummary: "1 change · 0 destroy",
    baselineScore: 1.2,
    candidateScore: 1.2,
    rangeLabel: "Inside its recent range",
    status: "routine",
    assessment: "Routine",
    headline: "This stack stays inside its normal range.",
    explanation: "A single in-place change is consistent with the stack's recent successful runs.",
    baseline: "Recent successes: small in-place changes",
  },
] as const;
